<template>
  <consensus-settings-panel
    :review="review"
    :current-researcher="currentResearcher"
    @update-screening-votes-required="onUpdateScreeningVotesRequired"
    @update-full-text-review-votes-required="
      onUpdateFullTextReviewVotesRequired
    "
    @update-data-extraction-reports-required="
      onUpdateDataExtractionReportsRequired
    "
    @assign-permission="onAssignPermissionToReviewMember"
    @unassign-permission="onRemovePermissionFromReviewMember"
    @unassign-all="onRemovePermissionFromAllReviewMembers"
  />
</template>

<script>
import ConsensusSettingsPanel from './ConsensusSettingsPanel';
import { Review, Researcher } from '@/models';
import { mapActions } from 'vuex';

export default {
  name: 'ConsensusSettingsController',
  components: { ConsensusSettingsPanel },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      updateScreeningVotesRequired:
        'review/updateScreeningVotesRequired',
      updateFullTextReviewVotesRequired:
        'review/updateFullTextReviewVotesRequired',
      updateDataExtractionReportsRequired:
        'review/updateDataExtractionReportsRequired',
      addPermission: 'reviewMember/addPermission',
      removePermission: 'reviewMember/removePermission',
      removePermissionFromAll: 'reviewMember/removePermissionFromAll',
    }),
    onUpdateScreeningVotesRequired({
      changeRequiredVoteTo,
      strategy,
    }) {
      this.updateScreeningVotesRequired({
        review: this.review,
        screeningVotesRequired: changeRequiredVoteTo,
        strategy,
      });
    },
    onUpdateFullTextReviewVotesRequired({
      changeRequiredVoteTo,
      strategy,
    }) {
      this.updateFullTextReviewVotesRequired({
        review: this.review,
        fullTextReviewVotesRequired: changeRequiredVoteTo,
        strategy,
      });
    },
    onUpdateDataExtractionReportsRequired({ changeRequiredVoteTo }) {
      this.updateDataExtractionReportsRequired({
        review: this.review,
        dataExtractionReportsRequired: changeRequiredVoteTo,
      });
    },
    onAssignPermissionToReviewMember({ reviewMember, permission }) {
      this.addPermission({
        reviewMember,
        permission,
      });
    },
    onRemovePermissionFromReviewMember({ reviewMember, permission }) {
      this.removePermission({
        reviewMember,
        permission,
      });
    },
    onRemovePermissionFromAllReviewMembers(permission) {
      this.removePermissionFromAll({
        review: this.review,
        permission,
      });
    },
  },
};
</script>
